import { Share as DefaultShare } from '@humandigital-agency/share';

export class HeliomareShare extends DefaultShare {
    constructor(container) {
        super(container);

        this.order = [
            'facebook',
            'linkedin',
            'twitter',
            'email'
        ];

        this.medias.whatsapp.enabled = false;
        this.medias.native.enabled = false;

        this.medias.facebook.icon = '<svg class="sprite icon_social_facebook"><use xlink:href="#icon_social_facebook" /></svg>';
        this.medias.linkedin.icon = '<svg class="sprite icon_social_linkedin"><use xlink:href="#icon_social_linkedin" /></svg>';
        this.medias.twitter.icon = '<svg class="sprite icon_social_twitter"><use xlink:href="#icon_social_twitter" /></svg>';
        this.medias.email.icon = '<svg class="sprite icon_social_mail"><use xlink:href="#icon_social_mail" /></svg>';
    }

    bindEvents(tag, media) {
        tag.addEventListener('click', e => {
            e.preventDefault();

            if (media == 'native') {
                const data = {
                    title: this.title,
                    description: this.description,
                    url: this.url
                };

                try {
                    navigator.share(data);
                } catch (e) {
                    if (console && console.error) {
                        console.error(e);
                    }
                }
            } else {
                window.open(tag.href, 'NewWindow', `menubar=no,toolbar=no,status=no,width=570,height=570,top=${(screen.height - 570) / 2},left=${(screen.width - 570) / 2}`);
            }
        });
    }
}